import { AUTH_SUCCESS, AUTH_ERROR } from '.'

const authSuccessAction = (payload) => {
  return {
    type: AUTH_SUCCESS,
    payload
  }
}

const authErrorAction = (payload) => {
  return {
    type: AUTH_ERROR,
    payload
  }
}

export { authSuccessAction, authErrorAction }
